import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const AgentCodeName = (props) => {
  return (
    <FormGroup controlId="agentCodeName">
       <Col componentClass={ControlLabel} sm={2}>
          Agent Code *
       </Col>
       <Col sm={5}>
           <FormControl
              type="text"
              required
              onBlur={props.handleGetAgentName}
              onChange={props.handleChangeAgentCode}
              value={props.agentCode}
              autoComplete="off"
              disabled={props.systemRole === 'agent'}
              maxLength="8"
            />
      </Col>
     <Col sm={5}>
         <FormControl
            type="text"
            disabled={props.systemRole === 'agent'}
            required
            data-readOnly={props.readOnly}
            value={props.agentName}
            autoComplete="off"
         />
     </Col>
    </FormGroup>
  )
}

AgentCodeName.propTypes = {
  agentCode: PropTypes.string,
  agentName: PropTypes.string,
  handleGetAgentName: PropTypes.func,
  handleChangeAgentCode: PropTypes.func,
  systemRole: PropTypes.string,
  readOnly: PropTypes.bool
};

AgentCodeName.defaultProps = {
  readOnly: true
};

export default AgentCodeName;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/agentCodeName/AgentCodeName.js